import React from 'react';
import { FaInstagram } from 'react-icons/fa';

const artists = [
  { name: 'Dave Munro', instagram: '@dave_munro', url: 'https://instagram.com/dave_munro', image: '/troublebound--artist--DaveMunro.jpg' },
  { name: 'Mike LeDrew', instagram: '@mikeledrewtattoo', url: 'https://instagram.com/mikeledrewtattoo', image: '/troublebound--artist--MikeLedrew.jpg' },
  { name: 'Murray Brokenshire', instagram: '@murrmosavich', url: 'https://instagram.com/murrmosavich', image: '/troublebound--artist--MurrayBrokenshire.jpg' },
  { name: 'Adrian Sawyer', instagram: '@steadysawyer709', url: 'https://instagram.com/steadysawyer709', image: '/troublebound--artist--AdrianSawyer.jpg' },
  { name: 'K. Burton', instagram: '@glassclawtattoos', url: 'https://instagram.com/glassclawtattoos', image: '/troublebound--artist--KBurton.jpg' }
];

export default function Artists() {
  return (
    <section id="artists" className="p-8 text-center font-tattoo">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold uppercase mb-6 text-deepRed">Artists</h2>
      <div className="flex flex-wrap justify-center gap-6">
        {artists.map((artist, index) => {
          const [firstName, lastName] = artist.name.split(' ');
          return (
            <a
              key={index}
              href={artist.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-700 p-1 rounded-lg shadow-md w-full sm:w-64 flex flex-col items-center border-4 border-deepRed hover:scale-105 transform transition duration-300 ease-in-out"
            >
              <img
                src={artist.image}
                alt={artist.name}
                className="w-full h-auto rounded-md hover:opacity-80 transition duration-200"
              />
              <h3 className="text-xl md:text-2xl font-medium mt-2">
                <span>{firstName}</span>
                <br />
                <span>{lastName}</span>
              </h3>
              <div className="flex items-center text-brightRed hover:text-deepRed mt-2 transition duration-200">
                <FaInstagram className="mr-2" /> {artist.instagram}
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}
